var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job-saved-searches" },
    [
      _c("div", { staticClass: "bg-white w-100 p-2" }),
      _vm.savedSearchesRetrieved === false
        ? [
            _c(
              "div",
              { staticClass: "d-flex justify-content-center mt-4 pb-2" },
              [_c("b-spinner", { attrs: { variant: "primary" } })],
              1
            ),
          ]
        : [
            _vm.savedSearches.length > 0
              ? [
                  _vm.isMobile === false
                    ? _c(
                        "table",
                        { staticClass: "w-100 mt-4" },
                        [
                          _c("tr", [
                            _c("th"),
                            _c("th", [_vm._v(_vm._s(_vm.t.jobSearch_V2_Name))]),
                            _c("th", [
                              _vm._v(
                                _vm._s(_vm.t.jobSearch_V2_Search_Criteria)
                              ),
                            ]),
                            _c("th"),
                          ]),
                          _vm._l(_vm.savedSearches, function (item, index) {
                            return _c(
                              "tr",
                              {
                                key: index,
                                staticClass:
                                  "table-item bg-white border clickable",
                              },
                              [
                                _c(
                                  "td",
                                  { staticClass: "py-3 px-4 align-top" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "delete-icon" },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "trash",
                                            variant: "danger",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteSavedSearch(
                                                item.Id
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass: "py-3 pr-2 align-top",
                                    on: {
                                      click: function ($event) {
                                        return _vm.initiateSearch(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "table-title" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.SearchName) +
                                          " " +
                                          _vm._s(item.Country)
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass: "py-3",
                                    on: {
                                      click: function ($event) {
                                        return _vm.initiateSearch(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm._l(
                                      item.FilterStrings,
                                      function (item, index) {
                                        return _c(
                                          "b-badge",
                                          {
                                            key: index,
                                            staticClass: "m-1",
                                            attrs: { variant: "dark" },
                                          },
                                          [_vm._v(_vm._s(item))]
                                        )
                                      }
                                    ),
                                    item.ZipCode !== null &&
                                    item.ZipCode !== undefined
                                      ? _c(
                                          "b-badge",
                                          {
                                            staticClass: "m-1",
                                            attrs: { variant: "dark" },
                                          },
                                          [
                                            item.CityName !== null &&
                                            item.CityName !== undefined &&
                                            item.CityName !== ""
                                              ? _c(
                                                  "span",
                                                  { staticClass: "mr-2" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.CityName + ":"
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              _vm._s(item.ZipCode) +
                                                " - " +
                                                _vm._s(
                                                  _vm.t.jobSearch_V2_Radius
                                                ) +
                                                " " +
                                                _vm._s(item.Range) +
                                                " km"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._l(
                                      _vm.displayFilterName(
                                        item.JobCategoryFilter,
                                        _vm.jobCategories
                                      ),
                                      function (item, index) {
                                        return _c(
                                          "b-badge",
                                          {
                                            key: index,
                                            staticClass: "m-1",
                                            attrs: { variant: "dark" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.t.jobSearch_V2_Job_Category
                                              ) +
                                                ": " +
                                                _vm._s(item)
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._l(
                                      _vm.displayFilterName(
                                        item.CareerFilter,
                                        _vm.careers
                                      ),
                                      function (item, index) {
                                        return _c(
                                          "b-badge",
                                          {
                                            key: index,
                                            staticClass: "m-1",
                                            attrs: { variant: "dark" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.t.jobSearch_V2_Career_Level
                                              ) +
                                                ": " +
                                                _vm._s(item)
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._l(
                                      _vm.displayFilterName(
                                        item.IndustryFilter,
                                        _vm.industries
                                      ),
                                      function (item, index) {
                                        return _c(
                                          "b-badge",
                                          {
                                            key: index,
                                            staticClass: "m-1",
                                            attrs: { variant: "dark" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.t.jobSearch_V2_Industry
                                              ) +
                                                ": " +
                                                _vm._s(item)
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _c(
                                      "b-badge",
                                      {
                                        staticClass: "m-1",
                                        attrs: { variant: "dark" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.t.jobSearch_V2_Posted_Date
                                          ) +
                                            ": " +
                                            _vm._s(
                                              _vm.displayDateName(
                                                item.StartDateString
                                              )
                                            )
                                        ),
                                      ]
                                    ),
                                  ],
                                  2
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass: "p-2 py-3",
                                    on: {
                                      click: function ($event) {
                                        return _vm.initiateSearch(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: { icon: "chevron-right" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _c(
                        "div",
                        { staticClass: "mt-4" },
                        _vm._l(_vm.savedSearches, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "row border p-2" },
                            [
                              _c("div", { staticClass: "row w-100" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-1 py-2" },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        icon: "trash",
                                        variant: "danger",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteSavedSearch(item.Id)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col py-2",
                                    on: {
                                      click: function ($event) {
                                        return _vm.initiateSearch(item)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.SearchName))]
                                ),
                              ]),
                              _vm._m(0, true),
                              _c(
                                "div",
                                {
                                  staticClass: "row",
                                  on: {
                                    click: function ($event) {
                                      return _vm.initiateSearch(item)
                                    },
                                  },
                                },
                                [
                                  _vm._l(
                                    item.FilterStrings,
                                    function (item, index) {
                                      return _c(
                                        "b-badge",
                                        {
                                          key: index,
                                          staticClass: "m-1",
                                          attrs: { variant: "dark" },
                                        },
                                        [_vm._v(_vm._s(item))]
                                      )
                                    }
                                  ),
                                  item.ZipCode !== null
                                    ? _c(
                                        "b-badge",
                                        {
                                          staticClass: "m-1",
                                          attrs: { variant: "dark" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(item.ZipCode, item.Range) +
                                              " - " +
                                              _vm._s(
                                                _vm.t.jobSearch_V2_Radius
                                              ) +
                                              " " +
                                              _vm._s(item.Range) +
                                              " km"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._l(
                                    _vm.displayFilterName(
                                      item.JobCategoryFilter,
                                      _vm.jobCategories
                                    ),
                                    function (item, index) {
                                      return _c(
                                        "b-badge",
                                        {
                                          key: index,
                                          staticClass: "m-1",
                                          attrs: { variant: "dark" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.t.jobSearch_V2_Job_Category
                                            ) +
                                              ": " +
                                              _vm._s(item)
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._l(
                                    _vm.displayFilterName(
                                      item.CareerFilter,
                                      _vm.careers
                                    ),
                                    function (item, index) {
                                      return _c(
                                        "b-badge",
                                        {
                                          key: index,
                                          staticClass: "m-1",
                                          attrs: { variant: "dark" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.t.jobSearch_V2_Career_Level
                                            ) +
                                              ": " +
                                              _vm._s(item)
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._l(
                                    _vm.displayFilterName(
                                      item.IndustryFilter,
                                      _vm.industries
                                    ),
                                    function (item, index) {
                                      return _c(
                                        "b-badge",
                                        {
                                          key: index,
                                          staticClass: "m-1",
                                          attrs: { variant: "dark" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.t.jobSearch_V2_Industry
                                            ) +
                                              ": " +
                                              _vm._s(item)
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c(
                                    "b-badge",
                                    {
                                      staticClass: "m-1",
                                      attrs: { variant: "dark" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.t.jobSearch_V2_Posted_Date) +
                                          ": " +
                                          _vm._s(
                                            _vm.displayDateName(
                                              item.StartDateString
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                ]
              : [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mt-4" },
                    [
                      _c("h2", [
                        _vm._v(_vm._s(_vm.t.jobSearch_V2_No_Saved_Searches)),
                      ]),
                    ]
                  ),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [_c("hr")])
  },
]
render._withStripped = true

export { render, staticRenderFns }